import React from 'react';
import { CloseIcon } from '../Icons';
import PortalOverlayHeaderIconBtn, { PortalOverlayHeaderIconBtnProps } from './PortalOverlayHeaderIconBtn';

export type PortalOverlayHeaderCloseBtnProps = Omit<PortalOverlayHeaderIconBtnProps, 'Icon' | 'iconTestID' | 'position' | 'onPress'> & {
  onCloseRequest: () => void;
  position?: PortalOverlayHeaderIconBtnProps['position'];
};

export default function PortalOverlayHeaderCloseBtn({
  onCloseRequest,
  ...restProps
}: PortalOverlayHeaderCloseBtnProps) {
  return (
    <PortalOverlayHeaderIconBtn
      Icon={CloseIcon}
      onPress={onCloseRequest}
      iconTestID="close-modal"
      position="right"
      {...restProps}
    />
  );
}
